import { PlanType } from '@core/models'
import { useCurrentUser } from '@features/session'
import { usePlan } from './usePlan'

/**
 * Whether to show the "Try for free" CTA: guests and free-plan users see it; paid plans don't.
 * Mirrors audio-web `useShowTrySubscriptionButton` (`!session || plan.type === Free`) — the plan
 * comes from the `billing/plan` query, not the session `plan` (which `/me` doesn't populate during
 * coexistence). While the plan is loading `data` is undefined → the button stays hidden for
 * signed-in users until the plan resolves.
 */
export const useShowTrySubscriptionButton = () => {
    const { id: userId } = useCurrentUser()
    const { data: plan } = usePlan()

    return userId === 0 || plan?.type === PlanType.Free
}
